import { render, staticRenderFns } from "./CustomerStatusTable.vue?vue&type=template&id=ad873438"
import script from "./CustomerStatusTable.vue?vue&type=script&lang=js"
export * from "./CustomerStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports